import * as api from '../../redux/api/actions.js'

import { Link } from 'react-router-dom'
import { withRouter } from '../../utils/withRouterCompat'
import React, { Component } from 'react'

import Alert from '@mui/material/Alert'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import ZoetisLogo from '../../assets/img/logo_corte.png'
import { connect } from 'react-redux'
import { forgotPassword } from '../../redux/auth/actions.js'
import { isValidEmail } from '../../redux/common/utils'

class ForgotPassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      error: false,
      errorMessage: '',
      isDisconnected: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange = event => {
    const {
      target: { name, value }
    } = event
    this.setState(() => ({ [name]: value }))
  }

  async handleSubmit() {
    this.handleConnectionChange()
    const result = await this.props.forgotPassword(this.state)
    if (result.hasErrors) {
      this.setState({ errorMessage: result.title })
    } else {
      this.props.history.push('/login')
    }
  }

  canSubmit() {
    return isValidEmail(this.state.email)
  }

  keyHandler = e => {
    if (e.key === 'Enter' && this.canSubmit() && this.state.online) {
      this.handleSubmit()
    }
  }

  handleConnectionChange = () => {
    const condition = navigator.onLine ? 'online' : 'offline'
    if (condition === 'online') {
      const webPing = setInterval(() => {
        fetch('//google.com', {
          mode: 'no-cors'
        })
          .then(() => {
            this.setState({ isDisconnected: false }, () => {
              return clearInterval(webPing)
            })
          })
          .catch(() => this.setState({ isDisconnected: true }))
      }, 2000)
      return
    }

    return this.setState({ isDisconnected: true })
  }

  render() {
    const { isDisconnected, errorMessage } = this.state

    if (this.props.loading) {
      return (
        <Backdrop open>
          <CircularProgress color='inherit' />
        </Backdrop>
      )
    }

    return (
      <>
        <CssBaseline />
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
            px: 2,
            py: 4,
          }}
        >
          <Container maxWidth='xs' disableGutters>
            <Box
              sx={{
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 1,
                p: { xs: 3, sm: 4 },
              }}
            >
                <Typography component='div'>
                  <img
                    src={ZoetisLogo}
                    alt='Zoetis Gerar'
                    style={{
                      width: '100%'
                    }}
                  />

                  {this.props.success && (
                    <Alert
                      severity='success'
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      O email para recuperação de senha foi enviado. Caso não
                      receba, clique em enviar novamente!
                    </Alert>
                  )}

                  {this.props.error && (
                    <Alert
                      severity='error'
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      {errorMessage}
                    </Alert>
                  )}

                  {isDisconnected && (
                    <Alert
                      severity='error'
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      Não é possível utilizar este recurso sem internet. Retorne
                      quando houver conexão com a internet!
                    </Alert>
                  )}

                  <Container disableGutters>
                    <Container
                      disableGutters
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      <TextField
                        autoComplete='off'
                        id='login-form-email'
                        label='E-mail'
                        name='email'
                        variant='outlined'
                        type='text'
                        onChange={this.handleChange}
                        style={{
                          width: '100%',
                          backgroundColor: 'white'
                        }}
                        required
                        onKeyUp={this.keyHandler}
                        value={this.state.email}
                        error={this.state.error}
                        helperText={this.state.errorMessage}
                      />
                    </Container>

                    <Container
                      disableGutters
                      style={{
                        marginTop: '1em'
                      }}
                    >
                      <Button
                        variant='contained'
                        color='primary'
                        disableElevation
                        size='large'
                        style={{
                          width: '100%'
                        }}
                        disabled={!this.canSubmit()}
                        onClick={this.handleSubmit}
                      >
                        Enviar
                      </Button>
                    </Container>

                    <Box
                      fontWeight='fontWeightLight'
                      style={{
                        marginTop: '1em',
                        textAlign: 'center'
                      }}
                    >
                      <Link
                        to='/login'
                        style={{
                          color: '#333',
                          textDecoration: 'none'
                        }}
                      >
                        voltar
                      </Link>
                    </Box>
                  </Container>
                </Typography>
            </Box>
          </Container>
        </Box>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    forgotPassword: params => dispatch(forgotPassword(params))
  }
}

const mapStateToProps = state => ({
  loading: api.getApiLoading(state, `Account/ForgotPassword`),
  error: api.getApiError(state, `Account/ForgotPassword`) || false,
  success: api.getApiResult(state, `Account/ForgotPassword`) || false
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ForgotPassword))
